import { $SERVER } from "~/util/Loaders";
import { $API } from "~/util/Loaders";
import { z } from "zod";
import { signIn } from "~/auth.server";
import { Login } from "~/lib/auth/login.server";
import { pg } from "~/pg.server";
import { eq } from "drizzle-orm";

export const unlinkDiscordApi = $API({
  path: "api/auth/unlinkDiscord",
  method: "POST",
  parser: z
    .object({
      userId: z.number(),
    })
    .strict(),
})(
  $SERVER?.(async (cx) => {
    const { input, req } = cx;

    const sess = req.sess;
    if (!sess) {
      return { t: "error" as const, error: "Unexpected server error." };
    }

    if (input.userId === sess.user.id || sess.user.isAdmin) {
      try {
        await pg.db
          .delete(pg.userDiscords)
          .where(eq(pg.userDiscords.userId, input.userId));
        return { t: "success" as const };
      } catch (error) {
        return { t: "error" as const, error: "Unexpected server error." };
      }
    }
    return { t: "error" as const, error: "No access rights." };
  })
);
